import React, { useEffect, useState, useRef } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
export function BackgroundMusic() {
  const [isMuted, setIsMuted] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    const tryPlay = async () => {
      if (isPlaying) return;
      try {
        await audio.play();
        setIsPlaying(true);
        removeListeners();
      } catch {
        // Autoplay was prevented by the browser; retry on a user interaction.
      }
    };
    const interactionEvents = ['click', 'scroll', 'keydown', 'touchstart', 'mousemove', 'wheel', 'pointerdown'];
    const removeListeners = () => {
      interactionEvents.forEach(event => {
        document.removeEventListener(event, tryPlay);
      });
    };
    // Try to play immediately on load
    tryPlay();
    // Keep trying on every single interaction until the browser allows it
    interactionEvents.forEach(event => {
      document.addEventListener(event, tryPlay);
    });
    return removeListeners;
  }, []);
  const toggleMute = () => {
    if (audioRef.current) {
      audioRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
      // If not playing yet, try to play
      if (!isPlaying) {
        audioRef.current.play().then(() => {
          setIsPlaying(true);
        }).catch(() => {
          // The browser still requires a direct user interaction.
        });
      }
    }
  };
  return <>
      <audio ref={audioRef} loop preload="auto" autoPlay data-id="element-9">
        <source src="https://cdn.magicpatterns.com/uploads/pY7RoUzjkhKtzNnxhzQ3yK/videoplayback (1).mp4" type="audio/mp4" data-id="element-10" />
        Your browser does not support the audio element.
      </audio>

      {/* Notification for users */}
      {!isPlaying && !isMuted && <div className="fixed bottom-24 right-8 z-50 bg-darkBlue/90 border border-gold/50 text-gold px-4 py-2 rounded-lg text-sm font-cinzel animate-pulse pointer-events-none shadow-lg" data-id="element-11">
          Click anywhere to start music
        </div>}

      {/* Floating Music Control Button */}
      <button onClick={toggleMute} className="fixed bottom-8 right-8 z-50 w-14 h-14 rounded-full bg-gold/90 hover:bg-gold flex items-center justify-center transition-all hover:scale-110 shadow-[0_0_30px_rgba(212,175,55,0.5)] group" aria-label={isMuted ? 'Unmute music' : 'Mute music'} data-id="element-12">
        {isMuted ? <VolumeX className="w-6 h-6 text-darkerBlue" data-id="element-13" /> : <Volume2 className="w-6 h-6 text-darkerBlue" data-id="element-14" />}

        {/* Pulsing animation when playing */}
        {!isMuted && isPlaying && <span className="absolute inset-0 rounded-full bg-gold animate-ping opacity-75" data-id="element-15"></span>}
      </button>
    </>;
}